<template>
  <div>
    <Loading v-if="!requested" />
    <TopNavbar :bgColor="'bg-main'">
      <van-icon name="arrow-left" class="icon" @click="arrowLeft" />
      <div class="flex1">
        <div class="flex justify-between">
          <div>Choose Ship Type</div>
          <div @click="saveShipType">Save</div>
        </div>
      </div>
    </TopNavbar>
    <div class="container">
      <div class="rate-checking-content" v-if="easyparcel_list">
        <div class="ratechecking-list" v-for="(item, index) in easyparcel_list" :key="index" @click="chooseRateChecking(item)">
          <div class="flex flex-center justify-center">
            <img class="rate-logo" :src="item.courier_logo" />
            <div class="flex1 flex flex-center justify-center">
              <div class="flex1">
                <div class="rate-name">{{item.courier_name}}</div>
                <div class="rate-delivery">{{item.delivery}}</div>
              </div>
              <div class="rate-price">RM {{item.price}}</div>
            </div>
          </div>
        </div>
        <div v-if="ratecheckingLoading" class="ratechecking-loading">
          <van-loading class="loading-icon" type="spinner" color="#1989fa" size="50" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '@/components/common/Loading.vue'
import TopNavbar from '@/components/common/TopNavbar.vue'
import { Dialog } from 'vant'
import { mapGetters, mapActions } from 'vuex'
import { updateEasypacelRetechecking } from '@/api/api'

export default {
  name: 'shippmentChoose',
  components: { TopNavbar, Loading },
  data() {
    return {
      requested: true,
      ratecheckingLoading: false
    }
  },
  computed: {
    ...mapGetters(["delivery_current_storeinfo", "user_islogin", "user_detail", "lalamove_list", "easyparcel_list"])
  },
  created() {
  },
  methods: {
    arrowLeft() {
      window.history.back(-1)
    },
    saveShipType() {
      Dialog({
        message: '保存更新客户选择同商家指定物流供应商',
        confirmButtonText: 'Confirm'
      }).then(() => {
        // if (isBack) {
        //   this.arrowLeft()
        // }
      });
    },
    /**
    * 选择物流配送方式
    */
    chooseRateChecking(item) {
      const queryParams = { i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'update_easypacel_retechecking' }
      const actionName = Object.keys(queryParams).map(key => {
        let strVal = queryParams[key]
        return `${key}=${strVal}`
      }).join('&')
      this.ratecheckingLoading = true
      updateEasypacelRetechecking('/app/index.php?' + actionName, { easypacel_ratechecking_shipping: item }).then(res => {
        console.log('保存物流信息成功', res)
        // this.$emit('evtShipType', {})
        Dialog({
          message: res.msg,
          confirmButtonText: 'Confirm'
        }).then(() => {
          // window.history.go(-2)
          const storeid = this.delivery_current_storeinfo.id || 0
          const queryJson = { i: '2', c: 'entry', do: 'wapmenu', m: 'weisrc_dish', tablesid: '', storeid: storeid, mode: '2', append: '1', from_user: '', h5api: 'on' }
          this.$router.push({ path: "/delivery?i=2&c=entry&do=wapmenu&m=weisrc_dish&tablesid=&storeid=44&mode=2&append=1&from_user=&h5api=on", query: queryJson });
        });

      }).catch(error => {
        this.$toast('network timeout')
      })
    },
  }
}
</script>

<style lang="less">
@import url('../../assets/css/common.less');
body {
  background-color: #eeeeee;
}
.bgRed {
  background-color: @main !important;
}
.container {
  padding: 36px 0 0 0;
  background-color: #ffffff;
}
.rate-checking-content {
  position: relative;
}
.ratechecking-loading {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background-color: rgba(255, 255, 255, 80%);
  .loading-icon {
    text-align: center;
    padding-top: 30px;
  }
}
.ratechecking-list {
  padding: 15px 8px;
  div {
    margin: 0 5px;
  }
  .rate-logo {
    width: 60px;
  }
  .rate-name {
    font-size: 14px;
  }
  .rate-delivery {
    font-size: 10px;
  }
  .rate-price {
    font-size: 16px;
    color: chocolate;
    font-weight: bold;
  }
}
</style>